import script from "./thinkSellGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./thinkSellGoods.vue?vue&type=script&setup=true&lang=js"

import "./thinkSellGoods.vue?vue&type=style&index=0&id=23fb0cd9&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fb0cd9"]])

export default __exports__